import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { PageTemplate } from '@_widgets/common';

import { tokenLogic } from '@_features/auth';
import { authApi, authModel } from '@_entities/auth';

import { Bridge } from '@_shared/config';
import { CHARACTER_IMGS } from '@_shared/imgs';

import { createSignupURL } from './RedirectPage.logic';
import * as S from './RedirectPage.style';

export function RedirectPage() {
	const { type } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		const code = new URL(document.location.toString()).searchParams.get('code');

		if (!code) return;

		authApi
			.login(type as authModel.TLoginOAuth, code)
			.then(({ data: { status, access, userData } }) => {
				tokenLogic.setAccessToken(access);

				// 이미 회원인 유저일 때
				if (status === 'ACTIVE') {
					new Bridge().postUUID(userData.uuid);
					navigate('/', { replace: true });
				}

				// 유저가 회원이 아닐떄
				else {
					navigate(
						createSignupURL({
							type: type as authModel.TLoginOAuth,
							email: userData?.email,
							nickname: userData?.nickname,
							code: access,
						}),
						{ replace: true },
					);
				}
			})
			.catch(
				({
					response: {
						data: { errorType, error },
					},
				}) => {
					navigate(`/login?error_type=${errorType}&message=${error}`, {
						replace: true,
					});
				},
			);
	}, []);

	return (
		<PageTemplate header={false} nav={false}>
			<S.Container>
				<img src={CHARACTER_IMGS.READING_CHARACTER_IMG} alt="loading character" />
				<S.Text>
					로그인 중 •••
					<br />
					잠시만 기다려주세요
				</S.Text>
				<S.TextLink to="/">해당 페이지에서 벗어나실 수 없으신가요?</S.TextLink>
			</S.Container>
		</PageTemplate>
	);
}
